import useUserQueryStore from "../context/UserStore";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import MultiTenantClusterGetDto from "../dtos/multiTenantClusterDto";
import APIClient from "../services/apiClient";

interface AddClusterContext {
  previousClusters: MultiTenantClusterGetDto[];
}

const useAddCluster = (onAdd: (newData: MultiTenantClusterGetDto[]) => void) => {
  const queryClient = useQueryClient();
  const currentToken = useUserQueryStore((s) => s.userQuery.currentToken);
  const apiClient = new APIClient<MultiTenantClusterGetDto>("/MultiTenantCluster", currentToken!);

  return useMutation<MultiTenantClusterGetDto, Error, MultiTenantClusterGetDto, AddClusterContext>({
    mutationFn: apiClient.post,
    onMutate: (newCluster) => {
      const previousClusters = queryClient.getQueryData<MultiTenantClusterGetDto[]>(["clusters"]) || [];
      queryClient.setQueryData<MultiTenantClusterGetDto[]>(["clusters"], (clusters = []) => [newCluster, ...clusters]);

      return { previousClusters };
    },
    onSuccess: (savedCluster, newCluster) => {
      queryClient.setQueryData<MultiTenantClusterGetDto[]>(["clusters"], (clusters) =>
        clusters?.map((cluster) => (cluster.id === newCluster.id ? savedCluster : cluster))
      );
      const newClusters = queryClient.getQueryData<MultiTenantClusterGetDto[]>(["clusters"]) || [];

      onAdd(newClusters);
    },
    onError: (error, newCluster, context) => {
      if (!context) return;

      queryClient.setQueryData<MultiTenantClusterGetDto[]>(["clusters"], context.previousClusters);
    },
  });
};

export default useAddCluster;
